import { Calendar, Clock3, FileEdit, Settings, Table } from "lucide-react";

export const WORKSPACE_VIEW_META = Object.freeze({
  editor: Object.freeze({
    id: "editor",
    label: "Editor",
    icon: FileEdit,
  }),
  table: Object.freeze({
    id: "table",
    label: "Table",
    icon: Table,
  }),
  calendar: Object.freeze({
    id: "calendar",
    label: "Calendar",
    icon: Calendar,
  }),
  timelineV3: Object.freeze({
    id: "timeline-v3",
    label: "Timeline",
    icon: Clock3,
  }),
  preferences: Object.freeze({
    id: "preferences",
    label: "Settings",
    icon: Settings,
  }),
});

export const DESKTOP_WORKSPACE_ORDER = Object.freeze([
  "table",
  "editor",
  "calendar",
  "timelineV3",
]);

export const MOBILE_WORKSPACE_ORDER = Object.freeze([
  "editor",
  "calendar",
]);

export function getWorkspaceViewMeta(viewMode) {
  return WORKSPACE_VIEW_META[viewMode] ?? WORKSPACE_VIEW_META.editor;
}
